import { render, staticRenderFns } from "./EmailActivation.vue?vue&type=template&id=8fe39540&"
import script from "./EmailActivation.vue?vue&type=script&lang=ts&"
export * from "./EmailActivation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports